import SuggestionSimulatorComponent from "./SuggestionSimulatorComponent";
import { Box, Card, Divider, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import { useEffect } from "react";
import LaunchIcon from "@mui/icons-material/Launch";

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import MediaWithDynamicURL from "./MediaWithDynamicURL";
import { DYNAMIC_URL_REGEX } from "../../../../constants";

export const MediaHandler = ({
    media,
    thumbnail,
    height = "150px",
    width = "100%",
    style = {},
    iconPosition = "center"
}) => {

    const mediaType = media?.type || '';
    const mediaUrl = media?.url || '';
    const thumbnailUrl = thumbnail?.url || '';
    const handleOpenMedia = () => {
        if (mediaUrl) {
            window.open(mediaUrl, "_blank", "noopener,noreferrer");
        }
    };
    // Calculate icon position based on prop
    const getIconLeftPosition = () => {
        switch (iconPosition) {
            case 'left':
                return '12%';
            case 'right':
                return '73%';
            case 'center':
            default:
                return '50%';
        }
    };

    const iconStyles = {
        position: "absolute",
        left: getIconLeftPosition(),
        top: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "50px",
        zIndex: 1,
        color: "white",
        filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 1))"
    };

    // Handle Video (MP4)
    if (mediaType === "video/mp4" || mediaType.includes("video")) {
        return (
            <Box sx={{ position: "relative", height, width, ...style }}>
                <PlayCircleOutlinedIcon style={iconStyles} />
                {thumbnailUrl && (
                    <img
                        src={thumbnailUrl}
                        alt="Video thumbnail"
                        style={{
                            opacity: 0.8,
                            height: "100%",
                            width: "100%",
                            objectFit: "cover"
                        }}
                    />
                )}
            </Box>
        );
    }

    // Handle PDF
    if (mediaType.includes("pdf") || mediaType === "application/pdf") {
        return (
            <Box
                sx={{
                    position: "relative",
                    height,
                    width,
                    overflow: "",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #e0e0e0",
                    overflow: "hidden",
                    ...style
                }}
            >
                <PictureAsPdfIcon
                    sx={{
                        fontSize: "48px",
                        color: "#d32f2f",
                        opacity: 0.7,

                    }}
                />
                {mediaUrl &&
                    mediaUrl?.match(DYNAMIC_URL_REGEX) ? <MediaWithDynamicURL
                    url={mediaUrl}
                    alt="Media content"
                    style={{
                        height,
                        width,
                        objectFit: "cover",
                        position: "absolute",
                        ...style,
                    }}
                />
                    :
                    // <Box
                    //     component="iframe"
                    //     src={mediaUrl}
                    //     sx={{
                    //         position: "absolute",
                    //         top: 0,
                    //         left: 0,
                    //         height: "100%",
                    //         width: "100%",
                    //         border: "none",
                    //         opacity: 0.9,
                    //         overflow: "hidden",
                    //     }}
                    // />
                    <Tooltip title="Open file">
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={handleOpenMedia}
                            disabled={!mediaUrl}
                            sx={{
                                "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "primary.contrastText",
                                },
                                position: "absolute",
                                top: 0,
                                right: 0,
                            }}
                        >
                            <LaunchIcon />
                        </IconButton>
                    </Tooltip>

                }
            </Box>
        );
    }

    // Handle Images (default)
    return (
        <MediaWithDynamicURL
            url={mediaUrl}
            alt="Media content"
            style={{
                height,
                width,
                objectFit: "cover",
                ...style
            }}
        />
    );
};
